import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1d286d55&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/comfortaa.css?vue&type=style&index=0&lang=css&"
import style1 from "../assets/css/styles.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports